import { hasAnalyticsConsent } from './cookieConsent';

/** ID счётчика Яндекс.Метрики (публичный). */
export const YANDEX_METRIKA_ID = Number(
  process.env.REACT_APP_YANDEX_METRIKA_ID || '109694146',
);

let loadPromise = null;
let initialized = false;

export function getYandexMetrikaId() {
  return YANDEX_METRIKA_ID;
}

export function isYandexMetrikaInitialized() {
  return initialized;
}

function injectTagScript() {
  if (typeof document === 'undefined') return Promise.resolve();
  const src = `https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`;
  for (let j = 0; j < document.scripts.length; j += 1) {
    if (document.scripts[j].src === src) {
      return Promise.resolve();
    }
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Yandex Metrika script failed to load'));
    const first = document.getElementsByTagName('script')[0];
    if (first?.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else {
      document.head.appendChild(script);
    }
  });
}

function ensureYmStub() {
  if (typeof window === 'undefined') return;
  if (typeof window.ym === 'function') return;
  const queue = [];
  const stub = function ymStub(...args) {
    queue.push(args);
  };
  stub.a = queue;
  stub.l = Date.now();
  window.ym = stub;
}

/**
 * Загружает tag.js и инициализирует счётчик. Вызывать только после согласия на аналитику.
 * @param {{ webvisor?: boolean, clickmap?: boolean }} [options]
 */
export async function loadYandexMetrika(options = {}) {
  if (typeof window === 'undefined') return false;
  if (initialized) return true;
  if (!hasAnalyticsConsent()) return false;

  if (!loadPromise) {
    loadPromise = (async () => {
      ensureYmStub();
      await injectTagScript();
      window.ym(YANDEX_METRIKA_ID, 'init', {
        clickmap: options.clickmap !== false,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: options.webvisor !== false,
        ecommerce: 'dataLayer',
      });
      initialized = true;
      return true;
    })().catch((err) => {
      loadPromise = null;
      console.warn('[Metrika]', err);
      return false;
    });
  }

  return loadPromise;
}

/** Инициализация при уже сохранённом согласии (вызов из App). */
export function initYandexMetrikaIfConsented() {
  if (hasAnalyticsConsent()) {
    loadYandexMetrika({ webvisor: true, clickmap: true });
  }
}

export function yandexMetrikaHit(url, options = {}) {
  if (!initialized || typeof window === 'undefined' || typeof window.ym !== 'function') {
    return;
  }
  window.ym(YANDEX_METRIKA_ID, 'hit', url, options);
}

/** @internal сброс для тестов */
export function __resetYandexMetrikaForTests() {
  loadPromise = null;
  initialized = false;
  if (typeof window !== 'undefined') {
    delete window.ym;
  }
}
